import React, { Component } from 'react';
import './mapContainer.css';

class MapContainer extends Component {
  render() {
    return (
      <div className="map-frame-wrapper">
        <iframe
          title="Robust Architecture Workshop location"
          className="map-frame"
          src="https://www.google.com/maps?q=6.894879454966966,79.87141402145559&z=17&output=embed"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
        <a
          className="map-link"
          href='https://maps.google.com/?q=6.894879454966966,79.87141402145559'
          target='_blank'
          rel='noopener noreferrer'
        >
          Open in Google Maps
        </a>
      </div>
    );
  }
}

export default MapContainer;